/** اعتبارسنجی سمت کلاینت برای فرم استخدام — فقط فیلدهای حساس به فرمت */

export const isValidMobile = (value: string): boolean =>
  /^(\+98|0)?9\d{9}$/.test(value.trim().replace(/\s/g, ''));

export const isValidEmail = (value: string): boolean =>
  !value.trim() || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());

export const isValidLandline = (value: string): boolean =>
  !value.trim() || /^0\d{9,10}$/.test(value.trim().replace(/\D/g, ''));

/** الگوریتم استاندارد بررسی صحت کد ملی ایران (رقم کنترلی) */
export const isValidNationalId = (value: string): boolean => {
  const trimmed = value.trim();
  if (!trimmed) return true; // اختیاری است
  if (!/^\d{10}$/.test(trimmed)) return false;
  if (/^(\d)\1{9}$/.test(trimmed)) return false; // ده رقم یکسان معتبر نیست

  const digits = trimmed.split('').map(Number);
  const check = digits[9];
  const sum = digits.slice(0, 9).reduce((acc, d, i) => acc + d * (10 - i), 0);
  const remainder = sum % 11;
  return remainder < 2 ? check === remainder : check === 11 - remainder;
};

export type RecruitmentFieldKey = 'fullName' | 'lastName' | 'mobile' | 'email' | 'nationalId' | 'phone';

export function validateRecruitmentField(key: RecruitmentFieldKey, value: string): string | undefined {
  switch (key) {
    case 'fullName':
      return value.trim().length < 2 ? 'نام را کامل وارد کنید' : undefined;
    case 'lastName':
      return value.trim().length < 2 ? 'نام خانوادگی را کامل وارد کنید' : undefined;
    case 'mobile':
      return !isValidMobile(value) ? 'شماره موبایل معتبر نیست (مثال: 09123456789)' : undefined;
    case 'email':
      return !isValidEmail(value) ? 'ایمیل معتبر نیست' : undefined;
    case 'nationalId':
      return !isValidNationalId(value) ? 'کد ملی معتبر نیست' : undefined;
    case 'phone':
      return !isValidLandline(value) ? 'شماره تلفن ثابت معتبر نیست' : undefined;
    default:
      return undefined;
  }
}

/** سقف طول هر فیلد — دقیقاً هم‌تراز با محدودیت‌های DTO سمت سرور */
export const MAX_LENGTHS = {
  fullName: 120,
  lastName: 120,
  fatherName: 120,
  birthPlace: 120,
  nationality: 80,
  address: 500,
  phone: 20,
  positionTitle: 200,
  expectedSalary: 200,
  hoursLimitation: 200,
  otherSkills: 1000,
  educationDegree: 60,
  educationField: 120,
  educationUniversity: 200,
  educationEndYear: 20,
  educationStatus: 60,
  skillTool: 120,
  skillLevel: 60,
  skillExperienceDuration: 60,
  skillLastUsed: 60,
  courseTitle: 200,
  courseOrganizer: 200,
  courseYear: 20,
  courseDuration: 60,
  courseUsage: 300,
  experienceCompanyName: 200,
  experienceField: 200,
  experiencePosition: 200,
  experienceManagerNameOrTitle: 200,
  experienceMainResponsibilities: 1500,
  experienceEndReason: 1500,
  narrativeLong: 3000,
  narrativeMedium1500: 1500,
  narrativeMedium2000: 2000,
  narrativeShort1000: 1000,
} as const;
